import { Box, Card, FormHelperText, Grid, List, ListItem, ListItemText } from "@mui/material"
import { DebugBox, ReactHooksFormWrapper, SelectRequiredControl, TextAreaControl } from "@northpowerdev/np-react-utils"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useFetchJson from "../../../data/useFetchJson";
import { RadioGroupRequiredControl } from "../../styled/RadioGroupControl";


const fieldQANextStatusOptions = [
    {key: 'field-qa',      value: 'Field QA',      label: 'Field QA'},
    {key: 'remedial',      value: 'Remedial',      label: 'Remedial'},
    {key: 'eliminated',    value: 'Eliminated',    label: 'Eliminated'},
]

const lowHighOptions = [
    {key: 'high', value: 'High', label: 'High (some risk at ICP, e.g. neutral still connected)'},
    {key: 'low',  value: 'Low',  label: 'Low'},
]

const yesNoOptions = [
    {key: 'yes', value: 'Yes', label: 'Yes'},
    {key: 'no',  value: 'No',  label: 'No'},
]

const initialFormState = {
    // Assessment Audit
    fieldQAComplete: null,                // 'Yes' | 'No'
    fieldQAComments: '',                  // 'free text'
    remedialPriority: null,                 // 'Low', 'High'
    // Decision Making
    nextStatus: '',                         // 'Field QA', 'Field', 'Remedial', 'Eliminated'
}

export default function DlspFieldQAForm({fieldQADetails, statusHistory, icpNumber, assignee, onClose}) {

    const [qaNextStatus, setQANextStatus] = useState()
    const [registryStatus, setRegistryStatus] = useState()
    console.log("registryStatus: ", registryStatus)
    const { handleSubmit, control, formState: { errors }, setValue, watch, /* reset, getValues, trigger */ } = useForm({defaultValues: initialFormState});
    const watchAllFields = watch()

    const {
        isLoading: fieldQASaving,
        load: saveFieldQA,
        } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/submit-field-qa', {method: 'POST'})

    useEffect(() => {
        
        //
        // Triggers on start-up or assessment details change to pre-fill form fields
        // 
        if (fieldQADetails) {
            // QA Audit
            setValue('fieldQAComplete',     fieldQADetails.fieldQAComplete)
            setValue('fieldQAComments',     fieldQADetails.fieldQAComments)
            setValue('remedialPriority',    fieldQADetails.remedialPriority)
            
            // Decision Making
            setValue('nextStatus',          fieldQADetails.nextStatus)

            // updateStatusHelperTextAndOptionalFields(fieldQADetails.nextStatus)
            setQANextStatus(fieldQADetails.nextStatus)
        }
    }, [fieldQADetails, setValue])

    useEffect(() => {
        if (statusHistory) {
            if (statusHistory.length) {
                const currentRegistryStatus = statusHistory[statusHistory.length - 1]
                setRegistryStatus(currentRegistryStatus.status)

            }
        }
    }, [setValue, statusHistory])

    const onSubmit = async (data) => {
        console.log('DlspFieldQAForm onSubmit data', data)
        const fieldQAOptions = {
            params: {
                icp: icpNumber,
                nextStatus: data.nextStatus,
            },
            body: JSON.stringify(data)
        }

        const theAssessmentResponse = await saveFieldQA(fieldQAOptions)
        if (theAssessmentResponse !== undefined) {
            //
            // Field QA form was saved successfully and status was updated. 
            //
            onClose() // tell parent component we're done
        }
    }

    const handleNewStatusChange = (newStatus) => {
        console.log('handleNewStatusChange event', newStatus)

        // updateStatusHelperTextAndOptionalFields(newStatus)
        setQANextStatus(newStatus)

        //
        // If the new status is not Remedial clear the remedialPriority value.
        //
        if (newStatus !== 'Remedial') {
            setValue('remedialPriority', null)
        }

    }

    let qaCommentsHelperText
    switch (qaNextStatus) {
        case 'Field':
            qaCommentsHelperText = 'These comments are instructions to field inspector'
            break
        case 'Remedial':
            qaCommentsHelperText = 'These comments are instructions to Northpower Contracting'
            break
        default:
            qaCommentsHelperText = ' '
            break
    }

    return (
    
        <Card sx={{my:2, p:2, bgcolor: 'transparent'}}>
        <ReactHooksFormWrapper
                onSubmit={handleSubmit(onSubmit)}
                control={control}
                errors={errors}
                submitLabel="Save Field QA"
                isSubmitting={fieldQASaving}
                submittingLabel="Saving field QA..."
        >

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>

                    <RadioGroupRequiredControl control={control} errors={errors} fieldName={'fieldQAComplete'}
                        fieldLabel="Field QA is Complete" controlSx={{my: 2}} options={yesNoOptions}
                    /> <br />
                    <Box sx={{mb: 2}}>
                        <TextAreaControl control={control} errors={errors} fieldName={'fieldQAComments'}
                            fieldLabel="Field QA Comments" controlSx={{width: '100%', mt: -2}}
                            minRows={5} maxRows={5}
                        />
                        <FormHelperText sx={{mt: -1}}>{qaCommentsHelperText}</FormHelperText>
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>

                    <SelectRequiredControl
                        control={control}
                        errors={errors}
                        fieldName={'nextStatus'}
                        fieldLabel="Next task status"
                        options={fieldQANextStatusOptions}
                        controlSx={{minWidth: '80%'}}
                        onChange={(e) =>handleNewStatusChange(e.target.value)}
                    /> <br />

                    {
                        qaNextStatus === 'Remedial'
                        &&
                        <Box sx={{mb: 2}}>
                            <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialPriority'}
                                fieldLabel="Priority of Remedial Work" controlSx={{my: 2}} options={lowHighOptions}
                            /> <br />
                        </Box>
                    }


                </Grid>
                <Grid item xs={12} sm={6}>
                    <DlspStatusList registryStatus={registryStatus} />
                </Grid>
            </Grid>
                {/* <DebugBox title="fieldQADetails" stringify>{fieldQADetails}</DebugBox> */}
                <DebugBox title="qaNextStatus" stringify>{qaNextStatus}</DebugBox>
                <DebugBox title="errors" stringify>{errors}</DebugBox>
                <DebugBox title="watchAllFields" stringify>{watchAllFields}</DebugBox>
        </ReactHooksFormWrapper>
        </Card>
    )
}

function DlspStatusList({registryStatus}) {

    if (registryStatus && ["inactive", "active"].includes(registryStatus.toLowerCase())) {
        return (
            <List>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Field QA"    secondary="Leave this task in Field QA status so you can come back and finish it later." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Remedial"    secondary="Contact the customer to ask about decommissioning. Optionally also say remedial work is required by Northpower Contracting. Creates a Salesforce Case for the work. Your comments go on to the case." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Eliminated"  secondary="Assess this ICP as safe and still required by the customer." />
                </ListItem>
            </List>
        )
    } else {
        //
        // Registry status is most likely "Decommissioned" (other unlikely possibilities are "New" or "Ready")
        //
        return (
            <List>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Field QA"     secondary="Leave this task in Field QA status so you can come back and finish it later." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Remedial"      secondary="Say remedial work is required by Northpower Contracting. Creates a Salesforce Case for the work. Your comments go on to the case." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Eliminated"    secondary="Assess this ICP as safely decommissioned with no further work required." />
                </ListItem>
            </List>
        )
    }

}